export function zmanimOptions(location) {
    return {
        timeZoneId: location.timeZoneId,
        latitude: location.latitude,
        longitude: location.longitude,
        elevation: location.elevation,
        complexZmanim: true,
        date: new Date(),
    };
}

function assertZmanimLocation(options) {
    const errors = [];
    if (!Number.isFinite(options?.latitude)) {
        errors.push('The zmanim latitude has not been set up.');
    }
    if (!Number.isFinite(options?.longitude)) {
        errors.push('The zmanim longitude has not been set up.');
    }
    if (typeof options?.timeZoneId !== 'string' || options.timeZoneId.trim() === '') {
        errors.push('The zmanim time zone has not been set up.');
    }
    if (errors.length > 0) {
        throw new Error(errors.join(' '));
    }
    if (!Number.isFinite(options.elevation)) {
        options.elevation = 0;
    }
}

function assertZmanimDate(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        throw new Error('The zmanim date is invalid.');
    }
}

function assertZmanimTableRoot(root) {
    if (!root || typeof root.querySelector !== 'function') {
        throw new Error('Zmanim table root is missing.');
    }
}

function assertKosherZmanimLoaded() {
    if (typeof KosherZmanim === 'undefined' || typeof KosherZmanim.getZmanimJson !== 'function') {
        throw new Error('KosherZmanim is not loaded.');
    }
}

function readZmanimMap(options) {
    assertKosherZmanimLoaded();
    const payload = KosherZmanim.getZmanimJson(options);
    if (!payload || typeof payload.Zmanim !== 'object' || payload.Zmanim === null || Array.isArray(payload.Zmanim)) {
        throw new Error('KosherZmanim did not return zmanim.');
    }
    return payload.Zmanim;
}

function zmanString(zman) {
    const match = typeof zman === 'string' ? zman.match(/^\d{4}-\d{2}-\d{2}T(\d{2}):(\d{2}):(\d{2})/) : null;
    if (!match) {
        return '';
    }

    const hours = Number(match[1]);
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${match[2]}:${match[3]}`;
}

const ZMAN_KEYS = [
    'AlosHashachar',
    'Misheyakir10Point2Degrees',
    'SeaLevelSunrise',
    'SofZmanShmaMGA16Point1Degrees',
    'SofZmanShmaGRA',
    'SofZmanTfilaGRA',
    'Chatzos',
    'MinchaGedolaGreaterThan30',
    'PlagHamincha',
    'CandleLighting',
    'SeaLevelSunset',
    'Tzais',
    'Tzais72',
];

export function isAssurBemlacha(options) {
    assertZmanimLocation(options);
    options.date = new Date();
    const zmanim = readZmanimMap(options);
    const tzais = new Date(zmanim.Tzais72);
    if (zmanim.Tzais72 == null || Number.isNaN(tzais.getTime())) {
        throw new Error('The zmanim tzais time is invalid.');
    }

    const geoLocation = new KosherZmanim.GeoLocation('Location', options.latitude, options.longitude, options.elevation, options.timeZoneId);
    const zmanimCalendar = new KosherZmanim.ZmanimCalendar(geoLocation);
    zmanimCalendar.setCandleLightingOffset(18);
    const today = new Date();

    return zmanimCalendar.isAssurBemlacha(today.getTime(), tzais.getTime(), false);
}

export function populateZmanimTable(root, options) {
    assertZmanimTableRoot(root);
    assertZmanimLocation(options);
    assertZmanimDate(options.date);
    const zmanim = readZmanimMap(options);
    const jewishCalendar = new KosherZmanim.JewishCalendar();
    jewishCalendar.setGregorianDate(options.date.getFullYear(), options.date.getMonth(), options.date.getDate());
    const jewishDate = new KosherZmanim.JewishDate(options.date);
    const hdf = new KosherZmanim.HebrewDateFormatter();
    hdf.setHebrewFormat(true);
    hdf.setLongWeekFormat(true);
    hdf.setUseGershGershayim(true);

    const dateCell = root.querySelector('[data-zman-date]');
    if (dateCell) {
        dateCell.textContent = hdf.format(jewishDate);
    }

    ZMAN_KEYS.forEach((key) => {
        const cell = root.querySelector(`[data-zman="${key}"]`);
        if (!cell) {
            return;
        }
        const text = zmanString(zmanim[key]);
        if (text !== '') {
            cell.textContent = text;
        }
    });

    const candleLightingRow = root.querySelector('[data-zman-row="CandleLighting"]');
    if (candleLightingRow) {
        candleLightingRow.classList.toggle('d-none', !jewishCalendar.hasCandleLighting());
    }
}

export function checkCurrentShabbosMode(route) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: route,
            type: 'GET',
            success: function (response) {
                if (response && response.success) {
                    resolve(response.shabbos_mode);
                } else {
                    reject(response);
                }
            },
            error: reject,
        });
    });
}
